import { Icon } from '@fluentui/react';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';

export const useFileIcons = () => {

    //const PDFIcon = bundleIcon(DocumentPdfFilled, DocumentPdfRegular);

    const getFileIcon = (filename?: string) => {
        const ext = filename?.split('.').pop();

        return (<Icon {...getFileTypeIconProps({ extension: ext, size: 20, imageFileType: 'png' })} />);
    }

    return {
        getFileIcon
    };
}